import { render, staticRenderFns } from "./reporttipsfriteartoisdetail.vue?vue&type=template&id=6a9488a3"
import script from "./reporttipsfriteartoisdetail.vue?vue&type=script&lang=js"
export * from "./reporttipsfriteartoisdetail.vue?vue&type=script&lang=js"
import style0 from "./reporttipsfriteartoisdetail.vue?vue&type=style&index=0&id=6a9488a3&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports